"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var splide_1 = __importDefault(require("@splidejs/splide"));
var splide_extension_auto_scroll_1 = require("@splidejs/splide-extension-auto-scroll");
var splide_extension_intersection_1 = require("@splidejs/splide-extension-intersection");
var constants_1 = require("../data/constants");
var SplideSlider = /** @class */ (function () {
    function SplideSlider() {
        var _this = this;
        var _a, _b;
        this.sliderElements = document.querySelectorAll("[".concat(constants_1.DATA_SLIDER, "]"));
        this.autoplayCarouselElements = document.querySelectorAll("[".concat(constants_1.DATA_AUTOPLAY_CAROUSELS, "]"));
        // If no slider exists return
        if (!this.sliderElements || !this.autoplayCarouselElements) {
            return;
        }
        // Text Media Slider
        (_a = this.sliderElements) === null || _a === void 0 ? void 0 : _a.forEach(function (sliderElement) {
            // Set up normal slider
            var splideSlider = new splide_1.default(sliderElement, {
                type: 'loop',
                rewind: true,
                gap: '1rem',
                pagination: false,
                snap: true,
                mediaQuery: 'min',
                updateOnMove: true,
                breakpoints: {
                    1024: {
                        gap: '1rem',
                    },
                },
            });
            // Mount sliders
            splideSlider.mount();
            // Pause videos on slide move
            splideSlider.on('move', function () {
                _this.stopVideosOnSlideChange(splideSlider);
            });
        });
        // Autoplay Carousels
        (_b = this.autoplayCarouselElements) === null || _b === void 0 ? void 0 : _b.forEach(function (sliderElement) {
            // Set up autoplay carousel slider
            var splideAutoplayCarousels = new splide_1.default(sliderElement, {
                type: 'loop',
                drag: 'free',
                focus: 'center',
                arrows: false,
                pagination: false,
                perPage: 1,
                gap: '1rem',
                mediaQuery: 'min',
                fixedWidth: '16.875rem',
                autoScroll: {
                    speed: .5,
                    pauseOnFocus: false,
                },
                intersection: {
                    inView: {
                        autoScroll: true,
                    },
                    outView: {
                        autoScroll: false,
                    },
                },
                breakpoints: {
                    512: {
                        perPage: 2,
                        fixedWidth: null,
                    },
                    1024: {
                        perPage: 3,
                    },
                    1280: {
                        perPage: 4,
                        gap: '1.5rem',
                    },
                    1600: {
                        gap: '2rem',
                    },
                },
            });
            // Mount sliders
            splideAutoplayCarousels.mount({ AutoScroll: splide_extension_auto_scroll_1.AutoScroll, Intersection: splide_extension_intersection_1.Intersection });
        });
    }
    // Stop videos on slide change
    SplideSlider.prototype.stopVideosOnSlideChange = function (Slider) {
        // Get all videos with controls for current slider
        var mp4Videos = Slider.root.querySelectorAll("[".concat(constants_1.DATA_VIDEO_HAS_CONTROLS, "]"));
        // Stop MP4
        mp4Videos === null || mp4Videos === void 0 ? void 0 : mp4Videos.forEach(function (video) {
            video.pause();
        });
    };
    return SplideSlider;
}());
exports.default = SplideSlider;
